import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaProjectDiagram, FaSmile, FaAward, FaUsers } from 'react-icons/fa';
import './StatsSection.css';

const StatsSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  const stats = [
    { number: '500', suffix: '+', label: 'Projects Completed', icon: <FaProjectDiagram />, color: '#D4AF37' },
    { number: '1000', suffix: '+', label: 'Happy Clients', icon: <FaSmile />, color: '#4CAF50' },
    { number: '15', suffix: '+', label: 'Years Experience', icon: <FaAward />, color: '#2196F3' },
    { number: '50', suffix: '+', label: 'Expert Team', icon: <FaUsers />, color: '#FF9800' }
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const item = {
    hidden: { opacity: 0, scale: 0.8, y: 50 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { 
        duration: 0.6, 
        ease: [0.6, -0.05, 0.01, 0.99]
      }
    }
  };

  const CountUp = ({ end, suffix, inView }) => {
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
      if (inView) {
        let start = 0;
        const duration = 2000;
        const increment = end / (duration / 16);
        
        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCount(end);
            clearInterval(timer);
          } else {
            setCount(Math.floor(start));
          }
        }, 16);

        return () => clearInterval(timer);
      }
    }, [inView, end]);

    return <span>{count}{suffix}</span>;
  };

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-background-overlay"></div>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Our <span>Achievements</span></h2>
          <p className="section-subtitle">Building Excellence in Coimbatore Since 2009</p>
        </motion.div>

        <motion.div
          className="stats-grid"
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={container}
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card"
              variants={item}
              whileHover={{ 
                y: -10,
                transition: { duration: 0.3 }
              }}
            >
              <div className="stat-card-inner">
                <div className="stat-icon-wrapper" style={{ background: `${stat.color}15` }}>
                  <div className="stat-icon" style={{ color: stat.color }}>
                    {stat.icon}
                  </div>
                </div>
                <div className="stat-content">
                  <h3 className="stat-number">
                    <CountUp end={parseInt(stat.number)} suffix={stat.suffix} inView={inView} />
                  </h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
                <div className="stat-decoration" style={{ background: stat.color }}></div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
